import { useRef } from 'react';
import { ScrollContext } from './ScrollContext';

const ScrollRefProvider = ({ children }) => {
  const refs = {
    sidebar: {
      settings: useRef(null),
      'social-media': useRef(null),
      customization: useRef(null),
      overview: useRef(null)
    },
    overview: {
      'stats-overview-tour': useRef(null),
      'popular-talk-tour': useRef(null),
      'conversation-performance-tour': useRef(null),
      'sentiment-by-media-tour': useRef(null),
      'top-social-media-post-tour': useRef(null),
      'top-hashtag-tour': useRef(null),
      'sentiment-analysis-tour': useRef(null),
      'brand-popularity-tour': useRef(null),
      'top-news-tour': useRef(null)
    },
    'socmed-overview': {
      stats: useRef(null),
      'engagement-followers': useRef(null),
      'reach-performance': useRef(null),
      'conversation-trend': useRef(null),
      'group-object': useRef(null)
    }
  };
  return (
    <ScrollContext.Provider value={refs}>{children}</ScrollContext.Provider>
  );
};

export default ScrollRefProvider;
